export default {
  test: '测试',
  systemConfig: '系统设置',
  logout: '退出登录',
  tip: '提示',
  checkLogout: '真的要注销登录吗 ?',
  lockScreen: '锁定屏幕'
}
